// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YlXdbFSloeuSrsvaUlXD {
  color: var(--grey-color-350);
}

.TfeTHJfq8sZTYZw9EBQo {
  display: flex;
  align-items: left;
  flex-direction: row;
  font-size: 14px;
  gap: 4px;
  color: var(--grey-color-350);
}

.O46MlLBffFiFVudVmteJ {
  cursor: pointer;
  color: var(--grey-color-90);
  font-family: var(--font-stack-full-regular);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  position: relative;
  bottom: 7px;
}

.UWEW2DK77HaQruGfrn1w {
  position: relative;
  bottom: -7px;
}`, "",{"version":3,"sources":["webpack://./src/components/Breadcrumb/Breadcrumb.module.scss"],"names":[],"mappings":"AAAA;EACE,4BAAA;AACF;;AAEA;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,4BAAA;AACF;;AAEA;EACE,eAAA;EACA,2BAAA;EACA,2CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;AACF","sourcesContent":[".home {\n  color: var(--grey-color-350);\n}\n\n.breadcrumb {\n  display: flex;\n  align-items: left;\n  flex-direction: row;\n  font-size: 14px;\n  gap: 4px;\n  color: var(--grey-color-350);\n}\n\n.breadcrumbItem {\n  cursor: pointer;\n  color: var(--grey-color-90);\n  font-family: var(--font-stack-full-regular);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px;\n  position: relative;\n  bottom: 7px;\n}\n\n.breadcrumbHome {\n  position: relative;\n  bottom: -7px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"home": `YlXdbFSloeuSrsvaUlXD`,
	"breadcrumb": `TfeTHJfq8sZTYZw9EBQo`,
	"breadcrumbItem": `O46MlLBffFiFVudVmteJ`,
	"breadcrumbHome": `UWEW2DK77HaQruGfrn1w`
};
export default ___CSS_LOADER_EXPORT___;
